import { styled } from "@linaria/react";
import { contentPage } from "../../components";
const {
  Container: ContentContainer,
  H1
} = contentPage;
const Container = /*#__PURE__*/styled(ContentContainer)({
  name: "Container",
  class: "cli4kc2"
});

function Privacy(): JSX.Element {
  return <Container>
      <div className="Intro">
        <H1>Privacy Policy</H1>
      </div>
      <p>
        <strong>Last updated April 01, 2021</strong>
      </p>
      <p>
        Thanks for choosing to be part of our community at Fiberplane BV
        (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;).
        We&apos;re committed to protecting your personal information and your
        right to privacy.
      </p>
      <p>
        This privacy policy describes our privacy practices in relation to the
        use of our websites fiberplane.dev (the &quot;Website&quot;), our
        software, services, solutions, tools, and related applications, services
        and programs, including research and marketing activities, offered by us
        (the &quot;Services&quot;). If you do not agree with any terms in this
        privacy policy, please discontinue use of our Services immediately.
      </p>
      <p>
        If you have any questions or concerns about how we handle your personal
        information, please contact us at
        <a href="mailto:hi@fiberplane.com">hi@fiberplane.com</a>.
      </p>
      <h2>PERSONAL INFORMATION COLLECTION</h2>
      <h3>Personal Information Provided by You</h3>
      <p>
        The types of information we may collect include basic user information
        (such as your name, email address), company information and any other
        information you choose to provide.
      </p>
      <p>
        The personal information that you provide to us must be true, complete
        and accurate, and you must notify us of any changes to such personal
        information.
      </p>
      <h3>Information automatically collected</h3>
      <p>
        When you visit or use the Website, we automatically collect certain
        information.
      </p>
      <p>The information we collect includes:</p>
      <p>
        Log Information and Device Data: We collect information about your use
        of the Services, including the type and version of browser, machine and
        device you use, access times, usage times, launches, pages viewed,
        debug, your IP address, the page you visited before navigating to our
        Services and other statistics.
      </p>
      <p>
        Location Data. We collect location data such as information about your
        device&apos;s location. How much information we collect depends on the
        type and settings of the device you use to access the Website.
      </p>
      <h2>PERSONAL INFORMATION WE USE</h2>
      <p>
        We use personal information in order to enter into or perform a contract
        with you (with your consent), and/or for compliance with our legal
        obligations.
      </p>
      <p>We use the information we collect or receive to:</p>
      <ul>
        <li>Perform our agreement with you and with others;</li>
        <li>
          Process, evaluate and complete certain transactions involving the
          Services;
        </li>
        <li>Operate, evaluate, and improve the Services;</li>
        <li>Correspond with you to resolve queries or complaints;</li>
        <li>Protect and ensure safety of our Intellectual Property Rights;</li>

        <li>Comply with our legal obligations.</li>
      </ul>
      <h2>DISCLOSURE OF PERSONAL INFORMATION</h2>
      <p>We only share information on the following legal basis:</p>
      <ul>
        <li>
          With your consent: we may share your Personal Information if you have
          given us express approval to share your Personal Information for a
          specific purpose.
        </li>
        <li>
          To comply with laws: we may share your information if we are legally
          acquired to do so in order to comply with the applicable laws.
        </li>

        <li>
          To provide you with services: we may share your information if it is
          required do so in order to fulfil our contractual obligations to you.
        </li>
        <li>
          To fulfil business obligations: we may share your information if it is
          reasonably necessary to achieve our legitimate business interests.
        </li>
      </ul>
      <h2>COOKIES</h2>
      <p>
        We may use cookies and similar tracking technologies (like web beacons
        and pixels) to access or store information. Specific information about
        how we use such technologies and how you can refuse certain cookies is
        set out in our Cookie Notice.
      </p>
      <h2>DURATION OF STORED INFORMATION</h2>
      <p>
        We will only keep your personal information for the period necessary for
        the purposes for which it was collected or processed, unless we are
        required or permitted by law to keep it for longer (such as tax,
        accounting or other legal requirements). In general, the Personal
        Information is not stored by us for longer than 3 years, unless you do a
        prior deletion request.
      </p>
      <h2>PROTECTION OF YOUR PERSONAL INFORMATION</h2>
      <p>
        We aim to safeguard your personal information from unauthorized access,
        improper use or disclosure, unauthorized modification, or unlawful
        destruction or accidental loss. We utilize suitable security measures to
        protect the security of your personal information. Please take note that
        no electronic transmission over the Internet or information storage
        technology can be guaranteed to be 100% secure or error-free. Although
        we will do our best to protect your personal information, transmission
        of personal information to and from our Website is at your own risk. You
        should only access the Website within a secure environment.
      </p>
      <h2>MINORS</h2>
      <p>
        The Services are not for use by children under the age of 16 years and
        we do not knowingly collect, store, share, or use Personal Information
        of children under 16 years. If you are under the age of 16 years, please
        do not provide any Personal Information, even if prompted by the
        Services to do so. If you are under the age of 16 years and you have
        provided Personal Information, please ask your parent(s) or guardian(s)
        to notify us (<a href="mailto:hi@fiberplane.com">hi@fiberplane.com</a>)
        and we will delete all such Personal Information.
      </p>
      <p>YOUR EU PRIVACY RIGHTS</p>
      <p>
        Based on the GDPR you may have rights available to you in respect to
        your Personal Information, such as:
      </p>
      <ul>
        <li>
          To obtain a copy of your Personal Information together with
          information about how and on what basis that Personal Information is
          processed;
        </li>
        <li>
          To rectify inaccurate Personal Information (including the right to
          have incomplete Personal Information completed);
        </li>
        <li>
          To delete your Personal Information (where it is no longer necessary
          in relation to the purposes for which it was collected or processed);
        </li>
        <li>
          To restrict processing of your Personal Information under certain
          circumstances.
        </li>
        <li>
          To port your Personal Information in machine-readable format to a
          third party (or to you) when we justify our processing on the basis of
          your consent or the performance of an agreement with you;
        </li>
        <li>
          To withdraw your consent to our processing of your Personal
          Information (where that processing is based on your consent);
        </li>
        <li>
          To obtain, or see a copy of the appropriate safeguards under which
          your Personal Information is transferred to a third country or
          international organization outside of the European Economic Area; and
        </li>
        <li>
          To lodge a complaint with your local supervisory authority for data
          protection.
        </li>
      </ul>
      <p>
        In addition to the above rights, you have the right to object, on
        grounds relating to your particular situation, at any time to any
        processing of your Personal Information which we have justified on the
        basis of a legitimate interest, including profiling (as opposed to your
        consent) or to perform a contract with you. You also have the right to
        object at any time to any processing of your Personal Information for
        marketing or promotional purposes, including profiling for marketing or
        promotional purposes.
      </p>
      <h2>PRIVACY POLICY UPDATE</h2>
      <p>
        We may change this Privacy Policy from time to time. If we make changes,
        we will notify you by revising the date at the top of the statement, and
        sending further notification (for example, with a banner, or an email).
      </p>
      <h2>REVIEW, UPDATE, OR DELETE YOUR DATA COLLECTED BY US</h2>
      <p>
        To request to review, update, or delete your personal information,
        please contact us at
        <a href="mailto:hi@fiberplane.com">hi@fiberplane.com</a>. We will
        respond to your request within 30 days.
      </p>
    </Container>;
}

export default Privacy;

require("../../../.linaria-cache/src/pages/privacy/index.linaria.module.css");